<template lang="pug">
    div.loader.d-inline-block.mr-1(:style="style", v-if='alert.busy')
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'loader',
  data() {
    return {
      styles: {
        sm: 'border: 2px solid #f7f7f7; border-top: 2px solid #b0b0b0; width: 15px; height: 15px;',
        md: 'border: 16px solid #f7f7f7; border-top: 16px solid #b0b0b0; width: 120px; height: 120px;',
        lg: 'border: 16px solid #f7f7f7; border-top: 16px solid #b0b0b0; width: 120px; height: 120px;',
      },
    };
  },
  props: ['size', 'trigger'],
  computed: {
    ...mapState('alert', ['alert']),
    style() {
      return this.styles[this.size];
    },
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
.loader {
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/Loader.vue